import { createSvg } from '@r1-frontend/ui-kit/atoms/svg/createSvg';

const HomeWifi = ({ strokeWidth = 1.5 }) => (
    <>
        <g id={'contour'}>
            <path
                d='M10.07 2.81997L3.14004 8.37002C2.36004 8.99002 1.86002 10.3 2.03002 11.28L3.36001 19.24C3.60001 20.66 4.96002
                21.8101 6.40002 21.8101H17.6C19.03 21.8101 20.4 20.65 20.64 19.24L21.97 11.28C22.13 10.3 21.63 8.99002 20.86
                8.37002L13.93 2.82998C12.86 1.96998 11.13 1.96997 10.07 2.81997Z'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
        <g id={'guts'}>
            <path
                d='M11.9955 17H12.0045'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M9.88 14.38C11.15 13.17 12.85 13.17 14.12 14.38'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M16.24 12.2601C15.7 11.7301 15.1 11.3201 14.48 11.0201C12.89 10.2601 11.11 10.2601 9.51001 11.0201C8.89001 11.3201 8.3 11.7301 7.75 12.2601'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
    </>
);

export default createSvg(
    HomeWifi,
    'home-wifi',
);
